 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGH from '@/components/xhtml/03_Copyrigh'
 import XHTML02_TITLE_PA from '@/components/xhtml/02_Title_Pa'
 import XHTML01_SERIES_P from '@/components/xhtml/01_Series_P'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLE from '@/components/xhtml/05_Acknowle'
 import XHTML06_1__THE_N from '@/components/xhtml/06_1__The_N'
 import XHTML07_2__WHAT from '@/components/xhtml/07_2__What'
 import XHTML08_3__WHY_D from '@/components/xhtml/08_3__Why_D'
 import XHTML09_4__CAN_P from '@/components/xhtml/09_4__Can_P'
 import XHTML10_APPENDIX from '@/components/xhtml/10_Appendix'
 import XHTML11_5__DO_PA from '@/components/xhtml/11_5__Do_Pa'
 import XHTML12_APPENDIX from '@/components/xhtml/12_Appendix'
 import XHTML13_6__PARTI from '@/components/xhtml/13_6__Parti'
 import XHTML14_APPENDIX from '@/components/xhtml/14_Appendix'
 import XHTML15_7__HOW_P from '@/components/xhtml/15_7__How_P'
 import XHTML16_DATA_APP from '@/components/xhtml/16_Data_App'
 import XHTML17_NOTES from '@/components/xhtml/17_Notes'
 import XHTML18_REFERENC from '@/components/xhtml/18_Referenc'
 import XHTML19_INDEX from '@/components/xhtml/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowle",
 			"name" : "xhtml/05_Acknowle",
 			"component" : XHTML05_ACKNOWLE
 		},
 		{
 			"path" : "/xhtml/06_1__The_N",
 			"name" : "xhtml/06_1__The_N",
 			"component" : XHTML06_1__THE_N
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js